import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ModalVideo from 'react-modal-video';

import Lquote from './../../public/img/l_quote.png';
import anuradha_rao from './../../public/img/testimonial/anuradha_rao.jpg';
import bindu from './../../public/img/testimonial/bindu.png';
import ramnandan from './../../public/img/testimonial/ramnandan.jpg';
import anuradha from './../../public/img/testimonial/anuradha.png';
import yamini from './../../public/img/testimonial/yamini.jpg';
import mekhala_balaji from './../../public/img/testimonial/mekhala_balaji.png';
import rajkamal from './../../public/img/testimonial/rajkamal.jpg';
import karuna from './../../public/img/testimonial/karuna.png';


const items = [
  {
    id: 1,
    type:"video",
    src:anuradha_rao,
    urlstr:'uiqV8V4f6PE',
    caption: "Anuradha Rao",
    occupation: "PSBB | IIM Bangalore | Top Consulting Firm",
    header: `One of the ways in which teachers brought Math alive was HeyMath! 
    HeyMath! was a tool that helped me in visualizing. 
    It made maths more interesting.`,
    altText: "Anuratha Rao, Heymath user from IIM Banglore shares her journey"
  },
  {
    id: 2,
    type:"image",
    src:bindu,
    urlstr:'none',
    caption: "Bindu Subramaniam",
    occupation: "Parent of Mahati - Class II, NPS",
    header: `My daughter Mahati started using HeyMath! when she was three, and 
    she loved it so much she started giving tutorials to everyone she met! It's 
    so much fun that she never realized she was doing hard work and learning so much. 
    I think HeyMath! is an incredible resource for children to learn math, 
    and I can't recommend it enough.`,
    altText: "Bindu Subramaniam shares testimonial about Grade 2 Self-Paced Lessons"
  },
  {
    id: 3,
    type:"video",
    src:ramnandan,
    urlstr:'-BFo63cdLSY',
    caption: "Ramnandan Krishnamurthy",
    occupation: "PSBB | IIT Madras - CSE | Microsoft",
    header: `Thanks to HeyMath, we had a very hands-on learning experience in school. 
    What helped with HeyMath and the lab was it had all the other types of learning 
    (auditory, visual etc.) along with the textual. 
    One genre of topics that which really helped, especially from a 
    visual standpoint was geometry`,
    altText: "Ramnandan Krishnamurthy, Heymath user from IIT Madras provides his feeback"
  },
  {
    id: 4,
    type:"image",
    src:anuradha,
    urlstr:'none',
    caption: "Anuradha",
    occupation: "Arjun's Mom - Grade 3, AAIS, ECR",
    header: `My 8 year old loves Math and HeyMath! is a big reason behind that! 
    The lessons are cool and I find that the content is structured intuitively, 
    keeping the learner in mind. As a parent I'm impressed with Prasso that challenges 
    kids to master the topic yet there's no associated pressure 
    - such a welcome change from traditional methods! Highly 
    recommend this program to parents and teachers across curriculum!`,
    altText:"Anuradha shares testimonial about Grade 3 Self-Paced Lessons"
  },
  {
    id: 5,
    type:"video",
    src:yamini,
    urlstr:'8yKwHD8fANY',
    caption: "Yamini Prashanth", 
    occupation: "Grade 10, Vidya Mandir, Mylapore",
    header: `HeyMath! is like an after-school tutor for me as I can watch animated 
    lessons and review my concepts with a human voice guiding me through them. 
    HeyMath is like having access to the best math teacher at home. 
    If I have not understood a concept at school or if I missed a class for some reason, 
    I can learn it by myself on HeyMath`,
    altText:"Yamini Prashanth, Heymath user from Vidya Mandir Mylapore shares her story"
  },
  {
    id: 6,
    type:"image",
    src:mekhala_balaji,
    urlstr:'',
    caption: "Mekhala",
    occupation: "Grade 7, Bala Vidya Mandir, Chennai",
    header: `I like PLP because it's easy to use. It helps correct my
    mistakes by giving me recommended practice sums & sometimes videos too.`,
    altText:"Mekhala from Grade 7 shares testimonial about PLP"
  },
  {
    id: 7,
    type:"video",
    src:rajkamal,
    urlstr:'wYKQM3-Yb94',
    caption: "Rajkamal Ganesan",
    occupation: "The Indian High School, Dubai | IIM Bangalore | Vedanta Resources",
    header: `What I like about HeyMath teaching interface was how they were trying to bring in 
    concepts by focusing on real-life issues rather than through 
    just plain equations making even a layman understand. It makes math more fun.`,
    altText:"Rajkamal Ganesa, Heymath user from NIT Trichy tells his HeyMath! journey"
  },
  {
    id: 8,
    type:"image",
    src:karuna,
    urlstr:'',
    caption: "Karuna",
    occupation: "Karuna, Mother of Lyra",
    header: `My daughter has been quite wary of Maths in general and numbers in particular. 
    She is often frustrated and tries to avoid. We have found HeyMath! a great help.
    Not only are the concepts introduced creatively but practice sessions are so engaging
    that she loves repeating them endlessly. HeyMath! has made learning an enjoyable experience
    which she looks forward to and getting her to do Maths is no longer a struggle.`,
    altText:"Karuna shares testimonial of her 7 year old daughter using HeyMath!"
  }
];

class OurTestimonial extends PreLoginSessionCheck {
  constructor(props) {
    super(props);
    this.state = {
		  isOpen: false
		}
		this.openModal = this.openModal.bind(this)
		this.goNext = this.goNext.bind(this)
    	this.goPrev = this.goPrev.bind(this)
  }

	openModal (someValue) {
	    this.setState({isOpen: true})
	    this.videoId = someValue
	}

	goNext() {
	    if (this.swiper) this.swiper.slideNext()
	}
	 
	goPrev() {
	    if (this.swiper) this.swiper.slidePrev()
	}

  loadimage(item){
   if(item.type=="image"){
    return (
      <figure className="figure">
      <img src={item.src} className="figure-img img-fluid rounded" alt={item.altText}></img>
      <figcaption className="figure-caption"><div className="txtcaption">
        {item.caption}
        </div>
        <div className="txtoccupation">
        {item.occupation}
        </div></figcaption>
    </figure>
    )
   }else{
    return (
      <figure className="figure">
      <div onClick={this.openModal.bind(null,item.urlstr)}> 
      <img src={item.src} className="figure-img img-fluid rounded videoimg" alt={item.altText}></img>
      <span className="play-btn"></span>
      </div>
      <figcaption className="figure-caption"><div className="txtcaption">
        {item.caption}
        </div>
        <div className="txtoccupation">
        {item.occupation}
        </div></figcaption>
    </figure>
    )
   }
  }

    render() {
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight:true,
        autoplay:true,
        autoplaySpeed:3000,
        pauseOnHover:true
      };

      return (
       <div id="OurparFBSlider" className="mtb our-student">
<div className="container justify-content-md-center">
<h4>Students and Parents share their HeyMath! experience</h4> 
<div className="stud-cont">
          <Slider {...settings}>
          {(() => {
											return(
                        items.map((fbcomm, index) =>
                      <div className="fbcont" key={index}>
											
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 txtcont">

                      <div className="txtpart">
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 test-pic">
                             
                             {this.loadimage(items[index])}
                             
                        </div>

                        <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 test-cont">
                        <div className="txtimg">   
                        <img src={Lquote} />
                        </div>

                            <div className="txtheader">
                            {items[index].header}
                            </div>
                          </div>

                      </div>


														</div>
                             </div>
													)
											);											

									})()}			

      </Slider>
      </div>
          </div>
          <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
       </div>

      );
    }
  }




export default OurTestimonial;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/OurTestimonial.js